import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BOOK = {
  title: "The 12 Laws of Dating Dynamics",
  subtitle: "How to Balance the Power and Avoid One-sided Relationships",
  author: "Manuel Santana",
  price: 19.99,
  pages: 305,
  isbn: "979-8218677480",
  publisher: "Penmier Publishing",
  published: "May 20, 2025",
  dimensions: '6" × 0.69" × 9"',
  weight: "14.6 oz",
  format: "Paperback",
  language: "English",
  cover: "https://m.media-amazon.com/images/I/61kEZ9QHMaL.jpg",
};

export const LAWS = [
  {
    n: "01",
    title: "The Law of Natural Priority",
    body: "Individuals tend to prioritize sex over romance — or romance over sex — when making dating and relationship decisions. That prioritization is largely influenced by their biological and physiological propensity and inclination.",
  },
  {
    n: "02",
    title: "The Law of Relationship Formats",
    body: "A relationship's dynamic and flow of power is arranged based on how both parties initiate contact, how they interact, and their motive for the relationship.",
  },
  {
    n: "03",
    title: "The Law of Dating Scarcity",
    body: "Your positive or negative dating experiences are largely dependent on the abundance or shortage of available romantic and/or sexual options — or your perception of them.",
  },
  {
    n: "04",
    title: "The Law of Relational Modes",
    body: "People behave either romantically or erotically depending on the phase, stage, era, or season they are in — and will base their relationship (or lack thereof) on that current mode.",
  },
  {
    n: "05",
    title: "The Law of Leading & Resulting",
    body: "A relationship that begins mutually romantic will eventually require erotic energy from one or both parties. A relationship that begins erotic will eventually require romantic energy from one or both parties.",
  },
  {
    n: "06",
    title: "The Law of Progression & Regression",
    body: "All relationships — casual or committed — cycle through periods that require closeness and periods that require distance. Failure to honor what's required will disrupt the dynamic.",
  },
  {
    n: "07",
    title: "The Law of Running & Chasing",
    body: "At every moment, one party has more interest, passion, and desire than the other — and invests more. The roles reverse the instant the pursuant begins to flee.",
  },
  {
    n: "08",
    title: "The Law of Withholding & Activating",
    body: "Emotional desire can be created by the absence or deprivation of sexual energy. Sexual desire can be created by the absence or deprivation of emotional energy. Restraint shapes pull.",
  },
  {
    n: "09",
    title: "The Law of Relational Respect",
    body: "The longevity and loyalty of any relationship — casual or serious — depends on respect being established and earned by both parties from the inception. Without it, the dynamic fractures.",
  },
  {
    n: "10",
    title: "The Law of Dating Connections",
    body: "Relationships require varying forms of connection — and they must be mutual. If a necessary connection is missing or one-sided, the probability of success drops sharply.",
  },
  {
    n: "11",
    title: "The Law of Intentional Interest",
    body: "For a relationship to thrive, both parties must hold sufficient romantic interest in one another from the very beginning — and both must intend to build something genuine. Missing either, it languishes.",
  },
  {
    n: "12",
    title: "The Law of Market Leveraging",
    body: "Whoever holds more perceived or actual value in the Dating Market obtains more Relational Advantage — and, inevitably, more leverage in the dynamics of the relationship.",
  },
];

export const REVIEWS = [
  {
    name: "Amanda",
    quote: "Insightful and practical. A relationship guide that doesn't take sides — showing perspectives from both male and female. If you are looking to manifest a healthy, happy relationship I recommend this book.",
  },
  {
    name: "Shirley Barranco",
    quote: "WOW!!! There are some pointers ladies must know to better understand coming from a man's perspective. You are revealing some things about myself I didn't even know.",
  },
  {
    name: "Najae",
    quote: "From the start, it breaks down the basics of being in a relationship and the roles being played. For someone who struggles with relationships, this is a great help toward a healthy one.",
  },
  {
    name: "A coly",
    quote: "Great to finally have something that isn't favored towards either the male or female perspective. Insightful and inspiring all around, and I highly recommend!",
  },
  {
    name: "Christina",
    quote: "Such an amazing read. I would highly recommend it to anyone looking to seek love and understanding.",
  },
  {
    name: "Niomy Nolberto",
    quote: "I love this book! It just breaks everything down so well. And it is so well written!",
  },
];
